import api from './api';

export const getQueryAnalytics = async (range = '7d') => {
  const response = await api.get(`/analytics/queries?range=${range}`);
  return response.data;
};

export const getSCGUsageAnalytics = async (range = '7d') => {
  const response = await api.get(`/analytics/scg-usage?range=${range}`);
  return response.data;
};

export const getCostAnalytics = async (range = '7d') => {
  const response = await api.get(`/analytics/costs?range=${range}`);
  return response.data;
};
